/**
 * Transitions configuration based on the existing CSS custom properties
 */
export const transitions = {
  easing: {
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    easeOut: 'cubic-bezier(0, 0, 0.2, 1)',
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)',
  },
  duration: {
    shortest: 75, // --transition-duration-75
    shorter: 100, // --transition-duration-100
    short: 150, // --transition-duration-150
    standard: 200, // --transition-duration-200
    complex: 300, // --transition-duration-300
    enteringScreen: 200,
    leavingScreen: 150,
  },
};